import type { CreditNoteDto, RecurringInvoiceDto } from "../api/documents-api";
import { formatMoney } from "./invoice-mappers";

const PAYMENT_MODE_LABEL: Record<string, string> = {
  CASH: "Cash",
  BANK: "Bank Transfer",
  CARD: "Card",
  UPI: "UPI",
  CHEQUE: "Check",
  OTHER: "Other",
};

const RECURRING_STATUS: Record<string, string> = {
  ACTIVE: "Unpaid",
  PAUSED: "Draft",
  COMPLETED: "Paid",
  CANCELLED: "Cancelled",
};

const FREQUENCY_LABEL: Record<string, string> = {
  DAILY: "Daily",
  WEEKLY: "Weekly",
  MONTHLY: "1 Month",
  QUARTERLY: "3 Months",
  YEARLY: "1 Year",
};

const CREDIT_NOTE_STATUS: Record<string, string> = {
  DRAFT: "Draft",
  ISSUED: "Pending",
  APPLIED: "Paid",
  CANCELLED: "Cancelled",
};

function formatDate(iso: string) {
  return new Date(iso).toLocaleDateString("en-GB", {
    day: "2-digit",
    month: "short",
    year: "numeric",
  });
}

export function recurringToTableRow(r: RecurringInvoiceDto, index: number) {
  const due = Number.parseFloat(r.total) - Number.parseFloat(r.paidAmount);
  return {
    key: r.id,
    rowId: r.id,
    Image: `avatar-${(index % 12) + 1}.jpg`,
    ID: r.number,
    Customer: r.customer.displayName,
    Created_On: formatDate(r.createdAt),
    Recurring_Cycle: FREQUENCY_LABEL[r.frequency] ?? r.frequency,
    Issue_Date: formatDate(r.issueDate),
    Due_Date: r.dueDate ? formatDate(r.dueDate) : "—",
    Paid: formatMoney(r.paidAmount, r.currency),
    Due_Amount: formatMoney(String(Math.max(due, 0)), r.currency),
    Status: RECURRING_STATUS[r.status] ?? r.status,
  };
}

export function creditNoteToTableRow(cn: CreditNoteDto, index: number) {
  return {
    key: cn.id,
    rowId: cn.id,
    Credit_Note_ID: cn.number,
    Image: `avatar-${(index % 12) + 1}.jpg`,
    Customer: cn.customer.displayName,
    Amount: formatMoney(cn.total, cn.currency),
    Related_To: cn.relatedInvoice?.number ?? "—",
    Payment_Mode: cn.paymentMode ? (PAYMENT_MODE_LABEL[cn.paymentMode] ?? cn.paymentMode) : "—",
    Created_On: formatDate(cn.creditNoteDate),
    Status: CREDIT_NOTE_STATUS[cn.status] ?? cn.status,
  };
}

export function paymentModeLabel(mode: string | null | undefined) {
  if (!mode) return "—";
  return PAYMENT_MODE_LABEL[mode] ?? mode;
}
